//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class GlobalConfig {
    systemPassword : string;
    importConfigs : ImportConfig[];
    databaseConfig : DatabaseConfig;
    customOnOfficeFields : { [key: string]: { [key: string]: GetFieldsResponse; }; };
    tableIndexes : { [key: string]: string[]; };

    constructor() 
    {
    	            this.systemPassword = "" ;
                this.importConfigs = [];
                this.databaseConfig = new DatabaseConfig();
                this.customOnOfficeFields = {};
                this.tableIndexes = {};
        }
}

export class ImportConfig {
    name : string;
    onOfficeModules : string[];
    fileImportConfigs : BaseFileImportConfig[];
    isTestMode : boolean;
    triggerConfigs : TriggerConfiguration[];

    constructor() 
    {
    	            this.name = "" ;
                this.onOfficeModules = [];
                this.fileImportConfigs = [];
                this.isTestMode = false ;
                this.triggerConfigs = [];
        }
}

export class BaseFileImportConfig {
    isActive : boolean;
    filePath : string;
    type : string;
    isZip : boolean;

    constructor() 
    {
    	            this.isActive = false ;
                this.filePath = "" ;
                this.type = "" ;
                this.isZip = false ;
        }
}

export class TriggerConfiguration {
    isActive : boolean;
    startingHour : number;

    constructor() 
    {
    	            this.isActive = false ;
                this.startingHour = null ;
        }
}

export class DatabaseConfig {
    path : string;
    name : string;
    user : string;
    password : string;

    constructor() 
    {
    	            this.path = "" ;
                this.name = "" ;
                this.user = "" ;
                this.password = "" ;
        }
}

export class GetFieldsResponse {
    type : string;
    length : number;
    permittedvalues : { [key: string]: string; };
    default : string;
    filters : any[];
    dependencies : any[];
    compoundFields : any[];
    label : string;
    exclude : boolean;

    constructor() 
    {
    	            this.type = "" ;
                this.length = null ;
                this.permittedvalues = {};
                this.default = "" ;
                this.filters = [];
                this.dependencies = [];
                this.compoundFields = [];
                this.label = "" ;
                this.exclude = false ;
        }
}

export class FileSystemNode {
    text : string;
    children : string[];
    meta : FileSystemNodeMetaData;

    constructor() 
    {
    	            this.text = "" ;
                this.children = [];
                this.meta = new FileSystemNodeMetaData();
        }
}

export class FileSystemNodeMetaData {
    fullPath : string;
    isDirectory : boolean;

    constructor() 
    {
    	            this.fullPath = "" ;
                this.isDirectory = false ;
        }
}

export class DataTypeDefinition {
    name : string;
    dataType : string;
    dateFormat : string;
    length : number;

    constructor() 
    {
    	            this.name = "" ;
                this.dataType = "" ;
                this.dateFormat = "" ;
                this.length = null ;
        }
}

export class DbTableInfo {
    name : string;
    columns : DbColumnInfo[];

    constructor() 
    {
    	            this.name = "" ;
                this.columns = [];
        }
}

export class DbColumnInfo {
    name : string;
    dataType : string;
    comment : string;
    indexes : string[];

    constructor() 
    {
    	            this.name = "" ;
                this.dataType = "" ;
                this.comment = "" ;
                this.indexes = [];
        }
}

export class JobResultLog {
    date : string ;
    onOfficeImportResult : string[];
    fileListImportResult : string[];
    indexResult : string[];

    constructor() 
    {
    	            this.date = null;
                this.onOfficeImportResult = [];
                this.fileListImportResult = [];
                this.indexResult = [];
        }
}

export class TriggerInfo {
    jobName : string;
    jobGroup : string;
    triggerName : string;
    triggerGroup : string;
    triggerType : string;
    startTime : string ;
    endTime : string ;
    nextFireTime : string ;
    previousFireTime : string ;
    state : string;

    constructor() 
    {
    	            this.jobName = "" ;
                this.jobGroup = "" ;
                this.triggerName = "" ;
                this.triggerGroup = "" ;
                this.triggerType = "" ;
                this.startTime = null;
                this.endTime = null;
                this.nextFireTime = null;
                this.previousFireTime = null;
                this.state = "" ;
        }
}

export class SwaggerModelFiller {
    sqlFileImportConfig : SqlFileImportConfig;
    csvFileImportConfig : CsvFileImportConfig;
    xlsxFileImportConfig : XlsxFileImportConfig;
    xlsFileImportConfig : XlsFileImportConfig;

    constructor() 
    {
    	            this.sqlFileImportConfig = new SqlFileImportConfig();
                this.csvFileImportConfig = new CsvFileImportConfig();
                this.xlsxFileImportConfig = new XlsxFileImportConfig();
                this.xlsFileImportConfig = new XlsFileImportConfig();
        }
}

export class SqlFileImportConfig extends BaseFileImportConfig {
    tablePrefix : string;

    constructor() 
    {
    	        super();
		            this.tablePrefix = "" ;
        }
}

export class ExcelLikeFileConfig extends BaseFileImportConfig {
    tableName : string;
    dataTypes : DataTypeDefinition[];

    constructor() 
    {
    	        super();
		            this.tableName = "" ;
                this.dataTypes = [];
        }
}

export class CsvFileImportConfig extends ExcelLikeFileConfig {
    delimiter : string;

    constructor() 
    {
    	        super();
		            this.delimiter = "" ;
        }
}

export class XlsxFileImportConfig extends ExcelLikeFileConfig {

    constructor() 
    {
    	        super();
		    }
}

export class XlsFileImportConfig extends ExcelLikeFileConfig {

    constructor() 
    {
    	        super();
		    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}